export const modalScreens = {
  addToList: 'ADD_TO_LIST',
  createList: 'CREATE_LIST'
}

export const watchlistTypes = {
  defaultList: 'DEFAULT_LIST',
  namedList: 'NAMED_LIST'
}

export const maxWatchlists = 10

export const defaultAnalyticsComponentName = 'AddToListModal'

export const labels = {
  addToListTitle: 'Add To List',
  createListTitle: 'Create List',
  createNewListButton: 'Create New List',
  createButton: 'Create',
  doneButton: 'Done',
  listNameInputLabel: 'List name'
}

export const shareListModes = {
  snapshot: 'SNAPSHOT',
  live: 'LIVE'
}

export const TILE_EXIT_MS = 220

export const SHARE_LINK_EXPIRY_MESSAGE = 'This link is valid for 90 days.'
